import { EmployeeStatsModel } from 'api/dto/EmploeeStats.dto';
import { Employee } from 'model/Employee';
import { PaginationModel } from 'model/Pagination.dto';

export const STORE_NAME = 'employee';

export namespace EmployeeState {
  export type Domain = {
    list: Employee[];
    chosenEmployees: Employee[];
    listPagination: PaginationModel | null;
    employeeUploadStats: EmployeeStatsModel | null;
  };

  export const INITIAL_DOMAIN: Domain = {
    list: [],
    chosenEmployees: [],
    listPagination: null,
    employeeUploadStats: null,
  };
}
